export default [

    {
        path: '/pages/frame/systemInfoManage',
        name: '/pages/frame/systemInfoManage',
        meta: { title: '系统配置' },
        component: () => import('@/views/frame/systemInfoManage.vue')
    },
    {
        path: '/pages/frame/staffPrivilege',
        name: '/pages/frame/staffPrivilege',
        component: () => import('@/views/frame/staffPrivilege.vue')
    },
    {
        path: '/pages/frame/staffDetail',
        name: '/pages/frame/staffDetail',
        component: () => import('@/views/frame/staffDetail.vue')
    },
    {
        path: '/pages/frame/staff',
        name: '/pages/frame/staff',
        meta: { title: '员工信息' },
        component: () => import('@/views/frame/staff.vue')
    },

    {
        path: '/pages/frame/role',
        name: '/pages/frame/role',
        meta: { title: '角色权限' },
        component: () => import('@/views/frame/role.vue')
    },
    {
        path: '/pages/frame/registerProtocol',
        name: '/pages/frame/registerProtocol',
        meta: { title: '注册协议' },
        component: () => import('@/views/frame/registerProtocol.vue')
    },

    {
        path: '/pages/frame/privilege',
        name: '/pages/frame/privilege',
        component: () => import('@/views/frame/privilege.vue')
    },
    {
        path: '/pages/frame/paymentPool',
        name: '/pages/frame/paymentPool',
        meta: { title: '支付配置' },
        component: () => import('@/views/frame/paymentPool.vue')
    },
    {
        path: '/pages/frame/orgManage',
        name: '/pages/frame/orgManage',
        meta: { title: '组织信息' },
        component: () => import('@/views/frame/orgManage.vue')
    },
    {
        path: '/pages/frame/ChangeStaffPwd',
        name: '/pages/frame/ChangeStaffPwd',
        meta: { title: '修改密码' },
        component: () => import('@/views/frame/ChangeStaffPwd.vue')
    },
    {
        path: '/pages/frame/addStaffStep',
        name: '/pages/frame/addStaffStep',
        component: () => import('@/views/frame/addStaffStep.vue')
    },
    {
        path: '/pages/frame/addStaff',
        name: '/pages/frame/addStaff',
        component: () => import('@/views/frame/addStaff.vue')
    }
] 